import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';

const getTopicSId = topic => {
  const topicId = topic.id;
  let topicSId = topic.props?.sId;

  topicSId = topicSId || topicId;

  const interactions = getInteractionsInTopic(topic);

  // only list topics that have interactions
  if (!interactions.length) {
    return undefined;
  }

  const interaction = interactions[0];
  const interactionId = interaction.id;
  let interactionSId = interaction.props?.sId;

  interactionSId = interactionSId || interactionId;

  const location = `${topicSId}/${interactionSId}`;
  // console.log('LOCATION:', location);

  return location;
};

export default getTopicSId;
